import { combineReducers } from 'redux';
import EnumsManager from 'utils/EnumsManager';
import { SETUP_USERS_TOGGLE_DEPARTMENT_SELECT_DIALOG, SETUP_USERS_DEPARTMENT, SETUP_USERS_USERS, SETUP_USERS_PAGENATIONS, SETUP_USERS_EDIT_USER, SETUP_USERS_SEARCHKEY, SETUP_USERS_SCOPE_VALUE, SETUP_USERS_LAST_PAGE, SETUP_USERS_INCREMENT_TOTAL } from './actionType';


const { ScopeTypes } = EnumsManager;
const { All } = ScopeTypes;

const users = (state = {
  department_id: '',
  department_text: '',
  users: [],
  editUser: {},
  scope: All
}, action) => {
  const { type, ...payload } = action;
  switch (type) {
    case SETUP_USERS_DEPARTMENT:
      return Object.assign({}, state, { ...payload });
    case SETUP_USERS_USERS:
      return Object.assign({}, state, { ...payload });
    case SETUP_USERS_EDIT_USER:
      return Object.assign({}, state, { editUser: payload.user });
    case SETUP_USERS_SCOPE_VALUE:
      return Object.assign({}, state, { ...payload });
    default:
      return state;
  }
};
const usersDataTablePagination = (state = { perPage: EnumsManager.DefaultPageConfigs.PageSize, currentPage: 1, total: 0 }, action) => {
  switch (action.type) {
    case SETUP_USERS_PAGENATIONS:
      return {
        perPage: action.perPage,
        currentPage: action.currentPage,
        total: action.total,
      };

    case SETUP_USERS_LAST_PAGE:
      return {
        ...state,
        currentPage: Math.ceil(state.total / state.perPage)
      };

    case SETUP_USERS_INCREMENT_TOTAL:
      return {
        ...state,
        total: state.total + 1
      };

    default:
      return state;
  }
};
const searchKey = (state = { searchKey: '' }, action) => {
  const { type, ...payload } = action;
  switch (type) {
    case SETUP_USERS_SEARCHKEY:
      return Object.assign({}, state, { searchKey: payload.searchKey });
    default:
      return state;
  }
};
const ui = (state = {
  isDisplayDepartmentDialog: false,
}, action) => {
  const { type, ...payload } = action;
  switch (type) {
    case SETUP_USERS_TOGGLE_DEPARTMENT_SELECT_DIALOG:
      return Object.assign({}, state, { ...payload });
    default:
      return state;
  }
};
export default combineReducers({
  ui,
  users,
  usersDataTablePagination,
  searchKey,
});




// WEBPACK FOOTER //
// ./src/views/Setup/Users/flow/reducer.js